import React, { useState, useEffect } from "react";
import SvgIcon from "../../SvgIcon/SvgIcon";
import useColorMode from "../../../hooks/useColorMode";
import useDebounced from "../../../hooks/useDebounced";
import { IconName } from "../../../assets/icons";


interface SearchBarProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  iconKey?: IconName;
  delay?: number; // debounce ms
}

const SearchBar: React.FC<SearchBarProps> = ({
  value = "",
  onChange,
  placeholder = "Escriba para buscar...",
  iconKey = "search",
  delay = 350
}) => {
  const [colorMode] = useColorMode();
  const [focused, setFocused] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const debouncedValue = useDebounced(inputValue, delay);

  const isDark = colorMode === "dark";
  const wrapperBg = isDark ? "bg-strokedark" : "bg-stroke";
  const textColor = isDark ? "text-white" : "text-black";
  const placeholderColor = isDark ? "placeholder-gray-300" : "placeholder-gray-500";

  const isExpanded = focused || inputValue.trim().length > 0;

  // Emitir valor debounced al padre
  useEffect(() => {
    onChange(debouncedValue.trim());
  }, [debouncedValue]);

  return (
    <div
      className={`
        relative flex h-11 items-center 
        ${wrapperBg} rounded-full shadow-sm 
        transition-all duration-300 ease-in-out
        ${isExpanded ? "w-[22rem]" : "w-[16rem]"}
      `}
    >
      {/* Icono */}
      <div className="absolute left-4 top-1/2 -translate-y-1/2">
        <SvgIcon
          name={iconKey}
          width={20}
          height={20}
          className={`${isDark ? "fill-white" : "fill-body"}`}
        />
      </div>

      {/* Input */}
      <input
        type="text"
        value={inputValue}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        className={`
          h-full w-full rounded-full bg-transparent
          pl-12 pr-5 text-base font-medium 
          focus:outline-none ${textColor} ${placeholderColor}
        `}
      />
    </div>
  );
};

export default SearchBar;
